import { render, staticRenderFns } from "./HightLight.vue?vue&type=template&id=5e4c5e2b&scoped=true&"
import script from "./HightLight.vue?vue&type=script&lang=js&"
export * from "./HightLight.vue?vue&type=script&lang=js&"
import style0 from "./HightLight.vue?vue&type=style&index=0&id=5e4c5e2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c5e2b",
  null
  
)

export default component.exports